<template>
  <div class="modal fade" id="modalTransactions" tabindex="-1" role="dialog" aria-hidden="true">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{ isReplay ? 'Contestar Transações' : 'Estornar Transações' }}</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>

        <div class="modal-body">
          <div> O total de transações:  {{ cardTransactions.length }}  </div>
          <div> O total em R$:  {{ this.$extensions.array.sum(cardTransactions, (card) => card.amountPaid) }}  </div>
        </div>

        <div class="modal-footer">
          <button type="button" class="btn btn-outline-primary" @click="send">Sim</button>
          <button type="button" class="btn btn-secondary" data-dismiss="modal">Não</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CardTransactionsError from '@/errors/CardTransactionsError'
export default {
  name: 'AppModalToReverseCardTransactions',
  props: {
    cardTransactions: {
      type: Array,
      required: true
    },
    isReplay: {
      type: Boolean,
      required: true
    }
  },
  methods: {
    async send () {
      if (this.isReplay) {
        this.$parent.$refs.spinner.show('Contestando...')

        var cardTransactionsContested = this.cardTransactions.map((item) => {
          return { nsu: item.nsu, contested: true }
        })

        var result = await this.$api.cardTransactions.cancel(cardTransactionsContested)
        if (result.error) {
          this.$parent.$refs.spinner.hide()
          const modelError = new CardTransactionsError(result)
          const error = modelError.getMessage()
          this.$parent.$swal({
            type: 'error',
            title: 'Oops...',
            text: error
          })
        } else {
          this.$parent.$swal(
            'Pronto!',
            'As transações foram contestadas.',
            'success'
          )
          await this.$parent.search()
          this.$parent.$refs.spinner.hide()
        }
      } else {
        this.$parent.$refs.spinner.show('Estornando...')

        var cardTransactionsCancel = this.cardTransactions.map((item) => {
          return { nsu: item.nsu, contested: false }
        })

        var response = await this.$api.cardTransactions.cancel(cardTransactionsCancel)
        if (response.error) {
          const modelError = new CardTransactionsError(response)
          const error = modelError.getMessage()
          this.$swal({
            type: 'error',
            title: 'Oops...',
            text: error
          })
          this.$parent.$refs.spinner.hide()
        } else {
          this.$swal(
            'Pronto!',
            'As transações foram estornadas.',
            'success'
          )
          await this.$parent.search()
          this.$parent.$refs.spinner.hide()
        }
      }
      this.$parent.cardTransactionSelected = []
      // eslint-disable-next-line no-undef
      $('#modalTransactions').modal('toggle')
    }
  }
}
</script>
